import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import FloatingComposer from 'modules/ai/components/FloatingComposer';
import BetaPill from './BetaPill';
import NaviOrb from './NaviOrb';

const EmptyState: FC = () => {
  const { t } = useTranslate();

  return (
    <div className="navi-empty">
      <NaviOrb size={56} />
      <h2 className="navi-empty__title">{t('CHATBOT_Header')}</h2>
      <p className="navi-empty__subtitle">{t('CHATBOT_Subheader')}</p>
      <div className="navi-empty__beta">
        <BetaPill />
      </div>
      <div className="navi-empty__composer">
        <FloatingComposer autoFocus />
      </div>
      <p className="navi-empty__disclaimer">{t('CHATBOT_VerifyMessage')}</p>
    </div>
  );
};

export default EmptyState;
